export default {
    data() {
        return {
            snackbar: false,
            snackbarMessage: null,
            snackbarColor: null,
            snackbarTimeout: "2000",
            snackbarIcon: null
        };
    },
    methods: {
        launchSnackbar(message, color, time, icon){
            this.snackbarMessage = message
            this.snackbarColor = color
            this.snackbarTimeout = time
            this.snackbarIcon = icon
            this.snackbar = true
        }
    }
};
